webpackJsonp([15],{

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(372);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7e8aba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(452);
function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7e8aba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      labels: ['01', '02', '03', '04', '05', '06', '07', '08'],
      value: [200, 675, 410, 390, 310, 460, 250, 240]
    };
  }
});

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(451);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("3c873a80", content, true, {});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, ".v-sheet--offset{top:-24px;position:relative}", "", {"version":3,"sources":["/vercel/path0/src/pages/Home.vue"],"names":[],"mappings":"AACA,iBACE,UAAW,AACX,iBAAmB,CACpB","file":"Home.vue","sourcesContent":["\n.v-sheet--offset {\n  top: -24px;\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-3",attrs:{"max-width":"600"}},[_c('v-sheet',{staticClass:"v-sheet--offset mx-auto",attrs:{"color":"primary","elevation":"12","max-width":"calc(100% - 32px)"}},[_c('v-sparkline',{attrs:{"labels":_vm.labels,"value":_vm.value,"color":"white","line-width":"2","padding":"16"}})],1),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('div',{staticClass:"title font-weight-light mb-2"},[_vm._v("Contratos")]),_vm._v(" "),_c('div',{staticClass:"subheading font-weight-light grey--text"},[_vm._v("Quantidade de Contratoos por mês")]),_vm._v(" "),_c('v-divider',{staticClass:"my-2"}),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("\n      mdi-clock\n    ")]),_vm._v(" "),_c('span',{staticClass:"caption grey--text font-weight-light"},[_vm._v("Atualizado à 15 minutos atrás")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.a40d27be9ba0f7db531c.js